import React from 'react';
import Card from '../../Shared/Cards/CustomerCard/Card';
import { customerCards } from './data';
import './Styles/Stories.scss';

const Stories=()=>{
    return(
        <div className="stories-customer">
            <h1>Read our customer stories</h1>
            <div data-aos="zoom-in"
              data-aos-delay={100} className="cards">
                {customerCards.map((d) =>{
                    return(
                        <Card  {...d}/>
                    )
                })}
            </div>
        </div>
    )
};
export default Stories ;